import React from "react";
import { useConfig } from "../hooks/useConfig";

export const CalendarHeader = () => {
  const { weeksDiff, weeksToLive } = useConfig();
  const weeksLeft = weeksToLive - weeksDiff;
  return (
    <div>
      <h3>
        You've been alive for{" "}
        <span style={{ color: "rgb(193, 21, 49)", fontWeight: 600 }}>
          {weeksDiff}
        </span>{" "}
        weeks.
        <br />
        {parseInt(weeksLeft) <= 0 ? (
          <span>RIP.</span>
        ) : (
          <span>
            Still{" "}
            <span style={{ color: "rgb(15 167 3)", fontWeight: 600 }}>
              {weeksLeft}
            </span>{" "}
            weeks left.
          </span>
        )}
        {/* until you're {yearsToLive} years old. */}
      </h3>
      {weeksLeft > 0 && (
        <p
          style={{
            textAlign: "center",
            textDecoration: "underline",
            fontWeight: "400",
          }}
        >
          MAKE THE MOST OF IT.
        </p>
      )}
    </div>
  );
};
